import "./AboutUs.css";
import { useEffect, useState } from "react";

import about1 from "../../assets/about/1.png";
import about2 from "../../assets/about/2.png";
import about3 from "../../assets/about/3.png";
import about4 from "../../assets/about/4.png";
import about5 from "../../assets/about/5.png";
import about6 from "../../assets/about/6.png";
import about7 from "../../assets/about/7.png";
import about8 from "../../assets/about/8.png";

const aboutSlides = [
  {
    image: about1,
    alt: "Trainosys professional training team delivering practical learning programs",
  },
  {
    image: about2,
    alt: "Trainosys corporate training and professional development program",
  },
  {
    image: about3,
    alt: "Trainosys instructor-led professional training for workplace skills",
  },
  {
    image: about4,
    alt: "Trainosys technology and IT training for professionals",
  },
  {
    image: about5,
    alt: "Trainosys practical corporate learning and skills development",
  },
  {
    image: about6,
    alt: "Trainosys professional learners participating in hands-on training",
  },
  {
    image: about7,
    alt: "Trainosys instructor-led technical and business training",
  },
  {
    image: about8,
    alt: "Trainosys training solutions for organizations and professional teams",
  },
];

const trainingAreas = [
  "IT and technology training",
  "Artificial intelligence and machine learning",
  "Data analytics and business intelligence",
  "Power BI, Python and SQL training",
  "Cybersecurity and information security",
  "Cloud computing and digital transformation",
  "Project management and business skills",
];

function AboutUs() {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((current) =>
        current === aboutSlides.length - 1 ? 0 : current + 1
      );
    }, 3500);

    return () => clearInterval(timer);
  }, []);

  return (
    <section
      className="about-page about-section"
      id="about"
      aria-labelledby="about-title"
    >
      <div className="about-content">

        {/* SEO INTRO */}
        <header className="about-header">
          <p className="section-eyebrow">About Trainosys Singapore</p>

          <h2 id="about-title">
            Professional Training and Corporate Learning Solutions in Singapore
          </h2>

          <p className="about-lead">
            Trainosys Training Solutions provides professional training,
            corporate training, and workforce development programs designed
            for individuals, teams, and organizations. Our practical,
            instructor-led programs help professionals build relevant skills
            in IT, artificial intelligence, data analytics, cybersecurity,
            business, cloud computing, and digital transformation.
          </p>

          <p className="about-lead about-lead-secondary">
            Whether you are looking for IT training in Singapore, AI and data
            analytics training, cybersecurity courses, Power BI and Python
            training, project management programs, or customized corporate
            learning, Trainosys provides flexible training solutions that can
            be delivered through classroom, onsite, online, or hybrid formats.
          </p>
        </header>

        {/* MISSION / VISION */}
        <div className="about-card-grid">

          <article className="about-card">
            <span className="about-card-label">Our Mission</span>

            <h3>
              Empowering professionals through practical skills development
            </h3>

            <p>
              Our mission is to empower individuals and organizations with
              high-quality, value-driven training and professional development
              programs that turn learning into practical workplace capability.
            </p>
          </article>

          <article className="about-card">
            <span className="about-card-label">Our Vision</span>

            <h3>
              A trusted training partner for modern organizations
            </h3>

            <p>
              Our vision is to be a trusted professional training partner for
              technology leaders, businesses, and organizations seeking to
              strengthen their workforce, support digital transformation, and
              develop future-ready capabilities.
            </p>
          </article>

        </div>

        {/* IMAGE EXPERIENCE */}
        <div
          className="about-image-slider"
          aria-label="Trainosys training and learning environments"
          aria-live="polite"
        >
          {aboutSlides.map((slide, index) => (
            <img
              key={slide.image}
              src={slide.image}
              alt={slide.alt}
              className={`about-slider-image ${
                index === activeSlide ? "active" : ""
              }`}
              loading={index === 0 ? "eager" : "lazy"}
              decoding="async"
              aria-hidden={index !== activeSlide}
            />
          ))}
        </div>

        {/* TRAINING AREAS */}
        <section
          className="training-focus"
          aria-labelledby="training-focus-title"
        >
          <div className="training-focus-header">
            <p className="section-eyebrow">Training Areas</p>

            <h3 id="training-focus-title">
              Professional Training Programs for Today&apos;s Workplace
            </h3>

            <p>
              Trainosys supports professional development and organizational
              upskilling across high-demand technology, business, and
              workplace disciplines.
            </p>
          </div>

          <ul className="training-focus-list">
            {trainingAreas.map((area) => (
              <li key={area}>
                <span aria-hidden="true">✓</span>
                {area}
              </li>
            ))}
          </ul>
        </section>

        {/* LEARNING PHILOSOPHY */}
        <article className="learning-philosophy-card">
          <span className="about-card-label">
            Our Learning Philosophy
          </span>

          <h3>
            Practical, Instructor-Led and Workplace-Focused Learning
          </h3>

          <p>
            At Trainosys, we believe continuous learning is essential for
            professional growth and business innovation. Our training approach
            combines clear instruction, practical exercises, real-world
            examples, guided activities, and relevant workplace scenarios.
          </p>

          <p>
            This approach helps learners move beyond theory and develop
            practical capabilities they can apply in their roles, teams, and
            organizations.
          </p>

          <div className="about-actions">
            <a
              href="/courses"
              className="about-primary-link"
              aria-label="Explore Trainosys professional training courses"
            >
              Explore Training Courses
            </a>

            <a
              href="/contact"
              className="about-secondary-link"
              aria-label="Request a Trainosys corporate training proposal"
            >
              Request Corporate Training
            </a>
          </div>
        </article>

      </div>
    </section>
  );
}

export default AboutUs;
